export default {"src":"/blog/_next/static/media/instagram.9c82c618.svg","height":14,"width":15};